import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoToTopIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 60,
		height: 60,
		rx: 25,
		fill: "#FFBF3A"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 34.2016L29.3169 25L30.794 25L40 34.2053L39.2525 34.9963L30.3577 26.1038L29.7496 26.1038L20.7439 35L20 34.2016Z",
		fill: "black",
		stroke: "black",
		strokeWidth: .5
	})]
});
export default SvgGoToTopIcon;
